/**
 * LOGOS Voice Agent Configuration
 * ElevenLabs Conversational AI Integration
 * 
 * @author Dr. José Manuel Cadena Ortiz de Montellano
 * @framework Cadena Strategic Systems
 */

export const LOGOS_AGENT_CONFIG = {
  agentId: import.meta.env.VITE_ELEVENLABS_AGENT_ID || "agent_0401kgrq0q0kfwx9v29fje7eqd5j",

  // Mapeo de keys internos (English) → labels para el agente (Spanish)
  VARIABLE_LABELS: {
    sleep: "Sueño", nutrition: "Nutrición", exercise: "Ejercicio", energy: "Energía",
    peace: "Paz Interior", gratitude: "Gratitud", love: "Amor", joy: "Alegría",
    clarity: "Claridad", focus: "Enfoque", creativity: "Creatividad", wisdom: "Sabiduría",
    faith: "Fe", meditation: "Meditación", service: "Servicio", presence: "Presencia",
    family: "Familia", friendship: "Amistades", community: "Comunidad", compassion: "Compasión",
    meaning: "Sentido", mission: "Misión", contribution: "Contribución", legacy: "Legado",
    nourishment: "Nutrición Consciente", taste_presence: "Presencia Gustativa",
    food_harmony: "Armonía Alimentaria", gut_resonance: "Resonancia Intestinal",
  },

  // Mapeo inverso: nombres en español → keys internos
  SPANISH_TO_KEY: {
    // Primary Spanish names (pre-stripped of accents to match NFD normalization)
    "sueno": "sleep", "sueño": "sleep", "nutricion": "nutrition", "ejercicio": "exercise", "energia": "energy",
    "paz": "peace", "paz interior": "peace", "gratitud": "gratitude", "amor": "love", "alegria": "joy",
    "claridad": "clarity", "enfoque": "focus", "creatividad": "creativity", "sabiduria": "wisdom",
    "fe": "faith", "meditacion": "meditation", "servicio": "service", "presencia": "presence",
    "familia": "family", "amistad": "friendship", "amistades": "friendship", "comunidad": "community", "compasion": "compassion",
    "sentido": "meaning", "mision": "mission", "contribucion": "contribution", "legado": "legacy",
    "nutricion consciente": "nourishment", "presencia gustativa": "taste_presence",
    "armonia alimentaria": "food_harmony", "resonancia intestinal": "gut_resonance",
    // Common voice variations the agent might use
    "dormir": "sleep", "descanso": "sleep", "comida": "nutrition", "alimentacion": "nutrition",
    "deporte": "exercise", "actividad fisica": "exercise", "tranquilidad": "peace", "serenidad": "peace",
    "felicidad": "joy", "gozo": "joy", "concentracion": "focus", "atencion": "focus",
    "oracion": "faith", "proposito": "meaning", "amigos": "friendship",
    "alimento": "nourishment", "nutricion sagrada": "nourishment",
    // Also accept English keys directly
    "sleep": "sleep", "nutrition": "nutrition", "exercise": "exercise", "energy": "energy",
    "peace": "peace", "gratitude": "gratitude", "love": "love", "joy": "joy",
    "clarity": "clarity", "focus": "focus", "creativity": "creativity", "wisdom": "wisdom",
    "faith": "faith", "meditation": "meditation", "service": "service", "presence": "presence",
    "family": "family", "friendship": "friendship", "community": "community", "compassion": "compassion",
    "meaning": "meaning", "mission": "mission", "contribution": "contribution", "legacy": "legacy",
    "nourishment": "nourishment", "taste_presence": "taste_presence",
    "food_harmony": "food_harmony", "gut_resonance": "gut_resonance",
  },

  // Mapeo de dominios español → inglés
  DOMAIN_MAP: {
    "fisico": "physical", "emocional": "emotional", "mental": "mental",
    "espiritual": "spiritual", "relacional": "relational", "proposito": "purpose",
    "physical": "physical", "emotional": "emotional", "spiritual": "spiritual",
    "relational": "relational", "purpose": "purpose",
    "alimento": "alimento", "alimento sagrado": "alimento",
  },

  // Tab mapping
  TAB_MAP: {
    "estado": "estado", "dominios": "dominios", "capas": "capas",
    "trayectoria": "trayectoria", "montecarlo": "montecarlo",
    "teoria": "teoria", "manual": "manual",
  },
};
